// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import SelectpickerController from "./selectpicker_controller"
application.register("selectpicker", SelectpickerController)

import CheckboxDropdownController from "./checkbox_dropdown_controller"
application.register("checkbox-dropdown", CheckboxDropdownController)

